<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <ChangeBeforeAfter>
                    <template #before>
                        <!-- //  Y：有申請VU07(已申請)；N：申請VU07後又取消(未申請)；空白：沒有申請VU07(未申請)(保單無VU07條款,保單有VU07條款但沒有申請) -->
                        <div v-if="before.funddeFlg!=='Y'">
                            未指定
                        </div>
                        <ul
                            v-else
                            class=" divide-dashed divide-y -mr-2.5 md:-mr-4"
                        >
                            <li
                                v-for="(item, index) in before.vu07List"
                                :key="index"
                                class="dashed flex item-baseline pr-2.5 md:pr-4"
                            >
                                <div class="text-sm leading-loose flex-shrink-0 w-8">
                                    {{ item.order }}
                                </div>
                                <div class="md:flex flex-grow">
                                    <div class="md:mr-4 md:w-1/4 flex-shrink-0">
                                        <span>{{ item.bankName }}</span>
                                    </div>
                                    <div>
                                        <span>{{ item.fundCode }}/{{ item.fundName }}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </template>
                    <template #after>
                        <div v-if="after.funddeFlg!=='Y'">
                            未指定
                        </div>
                        <ul
                            v-else
                            class="divide-dashed divide-y -mr-2.5 md:-mr-4"
                        >
                            <li
                                v-for="(item, index) in after.vu07List"
                                :key="index"
                                class="dashed flex item-baseline pr-2.5 md:pr-4"
                            >
                                <div class="text-sm leading-loose flex-shrink-0 w-8">
                                    {{ item.order }}
                                </div>
                                <div class="md:flex flex-grow">
                                    <div class="md:mr-4 md:w-1/4 flex-shrink-0">
                                        <span>{{ item.bankName }}</span>
                                    </div>
                                    <div>
                                        <span>{{ item.fundCode }}/{{ item.fundName }}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </template>
                </ChangeBeforeAfter>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef, computed } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ChangeBeforeAfter from '@/components/template/ChangeBeforeAfter.vue';
import { makeSort } from '@/utils/array/makeSort';

export default {
    name: 'AFData',
    components: {
        CollapseConfirmData,
        ChangeBeforeAfter
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref('AF');

        const after = computed(() => {
            const info = data.value.after;
            info.vu07List = makeSort(info.vu07List, 'order');
            return info;
        });
        const before = computed(() => {
            const info = data.value.before;
            info.vu07List = makeSort(info.vu07List, 'order');
            return info;
        });
        const removeService = () => {
            emit('removeService', code.value);
        };
        return { code, after, before, data, removeService };
    },
};
</script>

<style lang="scss" scoped>
.dashed {
    @apply pt-1 pb-1 first:pt-0 last:pb-0.5;
}
</style>
